import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { footer_data } from "../redux/actions";
import { useSelector } from "react-redux";

const FooterOne = () => {
  const [bottom_footer_data, setData] = useState([]);
  const region = useSelector((state) => state.region.region);
  //const [regionData, setRegionData] = useState(null);
  const [bottom_data, setBottomData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    //setRegionData(region);
    if (region) {
      const getData = async () => {
        try {
          const result = await footer_data(); // Calling API function

          if (region === "AED") {
            setBottomData(result?.regions[0]?.data?.en?.aed_address);
          } else if (region === "QAR") {
            setBottomData(result?.regions[0]?.data?.en?.qar_address);
          } else if (region === "OMR") {
            setBottomData(result?.regions[0]?.data?.en?.omr_address);
          } else if (region === "SAR") {
            setBottomData(result?.regions[0]?.data?.en?.sar_address);
          }
        } catch (err) {
          setError("Failed to fetch data!");
        }
      };
      getData();
    }
  }, [region]);

  useEffect(() => {
    const getData = async () => {
      try {
        const result = await footer_data(); // Calling API function
        setData(result?.menus[0]?.menuItems[0]?.children); // Storing data in state
      } catch (err) {
        //setError("Failed to fetch data!");
      }
    };

    getData();
  }, []);
//   const AddressDisplay = ({ address }) => {
//     return (
//       <pre
//         style={{
//           fontFamily: "'Inter', sans-serif",
//           fontSize: "16px",
//           display: "flex", // Enables Flexbox
//           alignItems: "center", // Vertically centers content
//           justifyContent: "center", // Horizontally centers content (optional)
//           // height: "100%",
//           // color: "#1f2937", // Equivalent to text-gray-900
//           // backgroundColor: "#f3f4f6", // Optional: Light gray background
//           // padding: "10px",
//           // borderRadius: "5px",
//           // whiteSpace: "pre-wrap", // Ensures wrapping
//           // wordWrap: "break-word", // Prevents overflow
//         }}
//       >
//         <span className="text-md text-gray-900">{address}</span>
//       </pre>
//     ); // Automatically preserves line breaks
//   };

  return (
    <footer className="footer mt-32">
      <div className="container container-lg">
        <div className="footer-item-wrapper d-flex align-items-start flex-wrap">
          <div className="footer-item max-w-full max-width-md-50">
            <div className="footer-item__logo">
              <Link to="/">
                {" "}
                <img src="/assets/images/logo/dhofar-logo.svg" alt="" />
              </Link>
            </div>
            {/* <p className="mb-24">
              We're Grocery Shop, an innovative team of food supliers.
            </p> */}
            <div className="flex-align gap-16 mb-16">
              <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-md flex-shrink-0">
                <i className="ph-fill ph-map-pin" />
              </span>
              <span className="text-md text-gray-900 ">
                {bottom_data}
                {/* <AddressDisplay address={bottom_data} /> */}
              </span>
            </div>

            <div className="flex-align gap-16 mb-16">
              <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-md flex-shrink-0">
                <i className="ph-fill ph-phone-call" />
              </span>
              <div className="flex-align gap-16 flex-wrap">
                <Link
                  to="#"
                  className="text-md text-gray-900 hover-text-main-600"
                >
                  {bottom_footer_data[0]?.name}
                </Link>

                {/* <span className="text-md text-main-600 ">or</span>
                <Link
                  to="/tel:+00987654012"
                  className="text-md text-gray-900 hover-text-main-600"
                >
                  +00 987 654 012
                </Link> */}
              </div>
            </div>
            <div className="flex-align gap-16 mb-16">
              <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-md flex-shrink-0">
                <i className="ph-fill ph-envelope" />
              </span>
              <Link
                to="mailto:feedback@dhofarglobal.com"
                className="text-md text-gray-900 hover-text-main-600"
              >
                {bottom_footer_data[1]?.name}
              </Link>
            </div>
            <ul className="flex-align gap-16" style={{ paddingBottom: "10px" }}>
              <li>
                <Link
                  to="https://www.linkedin.com/"
                  className="w-32 h-32 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                >
                  <i className="ph-fill ph-linkedin-logo" />
                </Link>
              </li>
            </ul>
          </div>{" "}
          {bottom_footer_data && bottom_footer_data.length > 0}
          <div className="footer-item">
            <h6 className="footer-item__title">Information</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link to="#" className="text-gray-600 hover-text-main-600">
                  {bottom_footer_data[2]?.name}
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">Our Policy</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link to="#" className="text-gray-600 hover-text-main-600">
                  {bottom_footer_data[6]?.name}
                </Link>
              </li>
              <li className="mb-16">
                <Link to="#" className="text-gray-600 hover-text-main-600">
                  {bottom_footer_data[7]?.name}
                </Link>
              </li>
              <li className="mb-16">
                <Link to="#" className="text-gray-600 hover-text-main-600">
                  {bottom_footer_data[3]?.name}
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">Queries</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link to="#" className="text-gray-600 hover-text-main-600">
                  {bottom_footer_data[4]?.name}
                </Link>
              </li>
              <li className="mb-16">
                <Link to="#" className="text-gray-600 hover-text-main-600">
                  {bottom_footer_data[5]?.name}
                </Link>
              </li>
            </ul>
          </div>
          {/* <div className="footer-item">
            <h6 className="footer-item__title">Rules</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link
                  to="#"
                  className="text-gray-600 hover-text-main-600"
                ></Link>
              </li>
            </ul>
          </div> */}
          {/*  <div className="footer-item">
           <h6 className="">Shop on The Go</h6>
            <p className="mb-16">Marketpro App is available. Get it now</p>
            <div className="flex-align gap-8 my-32">
              <Link to="/https://www.apple.com/store" className="">
                <img src="assets/images/thumbs/store-img1.png" alt="" />
              </Link>
              <Link to="/https://play.google.com/store/apps?hl=en" className="">
                <img src="assets/images/thumbs/store-img2.png" alt="" />
              </Link>
            </div> 
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default FooterOne;
